import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Popover, { PopoverAnimationVertical } from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

import { updateVesselSize, updateVesselSizeUser } from 'actions/vessels/size';

class SelectedTextPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            numberVesselSize: null,
        };

        this.selectVesselSize = this.selectVesselSize.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e, fieldValue) {
        if (this.state.numberVesselSize === null) {
            return;
        }

        const newVesselSize = _.cloneDeep(this.props.vesselSizes[this.state.numberVesselSize]);
        const newUser = _.cloneDeep(this.props.vesselSizeUser);

        switch(fieldValue) {
        case 'term':
            newVesselSize.terms.push({ type: '', value: this.props.chosenText });
            break;
        // todo check for autocomplete user
        case 'email':
            newUser.email = this.props.chosenText;
            break;
        case 'company':
            newUser.company = this.props.chosenText;
            break;
        case 'name':
            newUser.name = this.props.chosenText;
            break;
        case 'surname':
            newUser.surname = this.props.chosenText;
            break;
        case 'phonecode':
            newUser.phones[0].code = this.props.chosenText;
            break;
        case 'phone':
            newUser.phones[0].phone = this.props.chosenText;
            break;
        }

        this.props.updateVesselSize(this.state.numberVesselSize, newVesselSize);
        this.props.updateVesselSizeUser(newUser);
        this.props.closePopover();
    }

    selectVesselSize(e, index, value) {
        this.setState({
            numberVesselSize: value,
        });
    }

    render() {
        let renderMenu = (<Menu onChange={this.onChange}>
            <MenuItem primaryText='Term' value='term' />

            <MenuItem primaryText='Email user' value='email' />
            <MenuItem primaryText='Company new user' value='company' />
            <MenuItem primaryText='Name new user' value='name' />
            <MenuItem primaryText='Surname new user' value='surname' />
            <MenuItem primaryText='Phone code new user' value='phonecode' />
            <MenuItem primaryText='Phone number new user' value='phone' />
        </Menu>);

        if (this.state.numberVesselSize === null) {
            renderMenu = null;
        }

        return (
            <div className='popup'>
                <Popover
                    open={this.props.openPopover}
                    anchorEl={this.props.anchorEl}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                    onRequestClose={this.props.closePopover}
                    animation={PopoverAnimationVertical}
                >
                    <div className='popup-choose'>
                        <div className='chosen'>
                            <div className='chosen-title'>
                                Chosen text
                            </div>
                            <div className='chosen-row'>
                                {`'${this.props.chosenText}'`}
                            </div>
                        </div>
                    </div>
                    <SelectField
                        floatingLabelText='Choose vessel size'
                        value={this.state.numberVesselSize}
                        onChange={this.selectVesselSize}
                        style={{
                            width: '200px',
                            padding: '0 10px',
                        }}
                    >
                        {
                            this.props.vesselSizes.map((item, i) => {
                                return (<MenuItem
                                    key={i}
                                    value={i}
                                    primaryText={`Vessel size - ${i + 1}`}
                                />);
                            })
                        }
                    </SelectField>
                    {renderMenu}
                </Popover>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {
            openPopover: ownProps.openPopover,
            anchorEl: ownProps.anchorEl,
            closePopover: ownProps.closePopover,
            chosenText: ownProps.chosenText,
            vesselSizes: state.vesselSizes.items,
            vesselSizesUser: state.vesselSizes.user
        };
    },
    dispatch => bindActionCreators({
        updateVesselSize, 
        updateVesselSizeUser,
    }, dispatch),
)(SelectedTextPopup);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Size/Content/SelectedTextPopup.jsx